import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import recruitmentReducer from "./recruitmentReducer";
import tabReducer from "./tabReducer";
import closedReducer from "./closedReducer";
import candidateListReducer from "./candidateReducer";
import suspendedReducer from "./suspendedReducer";
import projectDetailsReducer from "./projectDetailsReducer";
import requiredReducer from "./requiredReducer";
import jobListingReducer from "./jobReducer";
import mpLaunchesReducer from "./mpLaunchesReducer";

const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  tab: tabReducer,
  recruit: recruitmentReducer,
  closed: closedReducer,
  candidates: candidateListReducer,
  suspend: suspendedReducer,
  projectDetails: projectDetailsReducer,
  required: requiredReducer,
  jobs: jobListingReducer,
  mpLaunch:mpLaunchesReducer
});

export default rootReducers;
